import { render, staticRenderFns } from "./document-historic.vue?vue&type=template&id=8c280b5e&"
import script from "./document-historic.vue?vue&type=script&lang=js&"
export * from "./document-historic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c280b5e')) {
      api.createRecord('8c280b5e', component.options)
    } else {
      api.reload('8c280b5e', component.options)
    }
    module.hot.accept("./document-historic.vue?vue&type=template&id=8c280b5e&", function () {
      api.rerender('8c280b5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/document-historic.vue"
export default component.exports